import { useCallback, useState } from 'react';

import { queryClient } from '../api/network/queryClient';
import { getTicketQueryConfig } from '../api/queries/ticket';
import { Customer } from '../interfaces/Customer';
import { FCWithChild } from '../interfaces/Shared';
import { Ticket } from '../interfaces/Ticket';
import { TicketContext, TicketProviderStore } from './TicketContext';

interface TicketProviderProps {
  defaultTicket?: Ticket;
}

const TicketProvider: FCWithChild<TicketProviderProps> = ({ children, defaultTicket }) => {
  const [ticket, setTicket] = useState<Ticket | undefined>(defaultTicket);
  const [isInErrorMode, setIsInErrorMode] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const fetchTicket = useCallback(async (ticketId: string): Promise<Ticket | undefined> => {
    const ticket = await queryClient.fetchQuery(getTicketQueryConfig(ticketId));

    if (ticket) {
      setTicket(ticket);
    }

    return ticket;
  }, []);

  const setCustomer = useCallback((customer: Customer) => {
    if (ticket) {
      setTicket({ ...ticket, customer });
    }
  }, [ticket]);

  const store: TicketProviderStore = {
    ticket,
    isInErrorMode,
    showFeedback,
    fetchTicket,
    setTicket,
    setIsInErrorMode,
    setShowFeedback,
    customer: ticket?.customer,
    setCustomer
  };

  return (
    <TicketContext value={store}>
      {children}
    </TicketContext>
  );
};

export { TicketProvider };
